module.exports = __webpack_public_path__ + "static/media/momo_uta_cd.6f4fbd23.png";